let recaptchaLoaded = false;

export function loadRecaptchaOnce() {
  if (recaptchaLoaded || !window._recaptchaScripts) return;
  recaptchaLoaded = true;

  const { api, sitekey, actions } = window._recaptchaScripts;
  const { homepage, contactform } = actions;

  const apiScript = document.createElement("script");
  apiScript.src = api;
  apiScript.async = true;
  apiScript.addEventListener("load", () => {
    const execute = ({ action, func, params = [] }) => {
      grecaptcha
        .execute(sitekey, { action })
        .then((token) => {
          document.dispatchEvent(
            new CustomEvent("wpcf7grecaptchaexecuted", {
              detail: { action, token },
            }),
          );
        })
        .then(() => {
          if (typeof func === "function") func(...params);
        })
        .catch((e) => console.error(e));
    };

    grecaptcha.ready(() => {
      execute({ action: homepage });
    });

    document.addEventListener("change", () => {
      execute({ action: contactform });
    });

    if (typeof wpcf7 !== "undefined" && typeof wpcf7.submit === "function") {
      const originalSubmit = wpcf7.submit;
      wpcf7.submit = (form, opts = {}) => {
        execute({
          action: contactform,
          func: originalSubmit,
          params: [form, opts],
        });
      };
    }

    document.addEventListener("wpcf7grecaptchaexecuted", (e) => {
      document
        .querySelectorAll(
          'form.wpcf7-form input[name="_wpcf7_recaptcha_response"]',
        )
        .forEach((input) => input.setAttribute("value", e.detail.token));
    });
  });

  document.head.appendChild(apiScript);
}
